import ObservableModel from "util/ObservableModel";

export const maxDescriptionChar = 500;

export default ObservableModel.extend(
    {
        defaults: {
            description: "",
            location: 0,
            type: "unknown",
        },
    },
    function AnnotationModel() {
        const self = this;
        self.description.extend({
            maxLength: maxDescriptionChar,
        });
    }
);
